/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Reactivation_ConflictInputs */

const en_case_contact_reactivation_conflict = /** @type {(inputs: Case_Contact_Reactivation_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than one inactive contact in this case has these phone numbers. Select the contact you want to reactivate.`)
};

const pt_br2_case_contact_reactivation_conflict = /** @type {(inputs: Case_Contact_Reactivation_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de um contato inativo neste caso possui esses números de telefone. Selecione o contato que deseja reativar.`)
};

/**
* | output |
* | --- |
* | "More than one inactive contact in this case has these phone numbers. Select the contact you want to reactivate." |
*
* @param {Case_Contact_Reactivation_ConflictInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_reactivation_conflict = /** @type {((inputs?: Case_Contact_Reactivation_ConflictInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Reactivation_ConflictInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_reactivation_conflict(inputs)
	return pt_br2_case_contact_reactivation_conflict(inputs)
});